import { createContext } from "react";

import type useTrialFormIdentityById from "src/hooks/data/load/useTrialFormIdentityById";

/**
 * Describes the trial form identity loader state and its refresh/cache actions.
 */
export interface ITrialFormIdentityContext extends ReturnType<typeof useTrialFormIdentityById> {}

/**
 * Shares trial form identity state with descendants.
 *
 * Postconditions: Without a provider, data and error are undefined and both activity flags are
 * false. Default mutate and refresh calls fulfill with undefined without loading or updating data.
 * Assumptions: Consumers need a matching provider to observe live request state.
 */
export default createContext<ITrialFormIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined
});
